// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"e7a5b66a","237":"66412bcd","638":"0b255de8","881":"b785349d"}[chunkId] + ".chunk.js";
};